/** The branch a person last chose, on any screen: one choice shared by every page. */
const KEY = 'qms.branch'

export function rememberedBranch(): string | null {
  try {
    return window.localStorage.getItem(KEY)
  } catch {
    return null
  }
}

export function rememberBranch(id: string): void {
  try {
    if (id) window.localStorage.setItem(KEY, id)
  } catch {
    // Without storage the choice lasts as long as the page.
  }
}

/** The branch a screen starts on: the one it shows if still listed, else the shared choice,
 *  else the first active one, else the first. */
export function startingBranch(
  branches: ReadonlyArray<{ id: string; active?: boolean }>,
  remembered: string | null,
  current?: string,
): string {
  const has = (id: string | null | undefined) => Boolean(id) && branches.some((b) => b.id === id)
  if (has(current)) return current!
  if (has(remembered)) return remembered!
  return (branches.find((b) => b.active) ?? branches[0])?.id ?? ''
}
